// extracted by mini-css-extract-plugin
module.exports = {"outer":"PageStatus_outer__1RFuu","animatedBackground":"PageStatus_animatedBackground__3FRah","inner":"PageStatus_inner__2n1HF"};